import Vue from 'vue'
import Router from 'vue-router'
import fb from './firebaseConfig.js'

import Home from './views/Home.vue'
import Commercial from './views/Commercial/Commercial.vue'
import CommercialNeuf from './views/Commercial/Neuf.vue'
import CommercialAncien from './views/Commercial/Ancien.vue'
import CommercialSyndic from './views/Commercial/Syndic.vue'
import CommercialGestion from './views/Commercial/Gestion.vue'
import CommercialLoc from './views/Commercial/Loc.vue'
import Promotion from './views/Promotion/Promotion.vue'
import PromotionDetails from './views/Promotion/PromotionDetails.vue'
import Financier from './views/Financier/Financier.vue'
import RessourcesHumaines from './views/Rh/RessourcesHumaines.vue'
import Login from '@/views/Login'

import { store } from './store.js'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '*',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout'
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/commercial',
      name: 'commercial',
      component: Commercial
    },
    {
      path: '/commercial/neuf',
      name: 'commercial-neuf',
      component: CommercialNeuf
    },
    {
      path: '/commercial/ancien',
      name: 'commercial-ancien',
      component: CommercialAncien
    },
    {
      path: '/commercial/syndic',
      name: 'commercial-syndic',
      component: CommercialSyndic
    },
    {
      path: '/commercial/gestion',
      name: 'commercial-gestion',
      component: CommercialGestion
    },
    {
      path: '/commercial/location',
      name: 'commercial-loc',
      component: CommercialLoc
    },
    {
      path: '/promotion',
      name: 'promotion',
      component: Promotion
    },
    {
      path: '/promotion/:id',
      name: 'promotionDetails',
      component: PromotionDetails,
      props: true
    },
    {
      path: '/financier',
      name: 'financier',
      component: Financier,
      beforeEnter: requireDirection
    },
    {
      path: '/rh',
      name: 'rh',
      component: RessourcesHumaines,
      beforeEnter: requireDirection
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.name !== 'login')
  const currentUser = fb.auth.currentUser

  if(to.matched.some(x => x.name === 'logout')) {
    fb.auth.signOut().then(() => {
      store.commit('clear')
      next('/login')
    }).catch((error) => console.log(error))
  } else if (requiresAuth && !currentUser) {
    next('/login')
  } else if (requiresAuth && currentUser) {
    store.commit('setLoading')
    store.dispatch('fetchUser').then(() => {
      let fetches = [
        store.dispatch('fetchRapportCommercial'),
        store.dispatch('fetchRapportPromotion')
      ]

      if (store.state.user.fullAccess) {
        fetches.push(store.dispatch('fetchRapportFinancier'))
        fetches.push(store.dispatch('fetchRapportRh'))
      }

      Promise.all(fetches).then(() => {
        store.commit('setLoaded')
        next()
      }).catch((error) => console.log(error))
    }).catch((error) => {
      console.log(error)
      store.commit('setLoaded')
      next('/login')
    })
    
  } else {
    next()
  }
})

function requireDirection (to, from, next) {
  if (!store.state.user.fullAccess) {
    next('/')
  } else {
    next()
  }
}

export default router